import { Component, OnInit } from '@angular/core';
import {
  confirmResetPassword,
  confirmSignIn,
  resetPassword,
  signIn,
} from 'aws-amplify/auth';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Router } from '@angular/router';
import { AuthService } from 'src/core/services/auth.service';
import { LoaderService } from 'src/core/services/loader.service';
import { getLoginClientMetadata } from 'src/core/services/login-client-metadata';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss'],
    standalone: false
})
export class PortalComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  services: any = {
    handleSignIn: async (formData: { username: string; password: string }) => {
      const { username, password } = formData;
      this._loaderService.show();
      const clientMetadata = await getLoginClientMetadata();
      return signIn({
        username,
        password,
        options: { clientMetadata },
      });
    },

    handleConfirmSignIn: async (formData: { code: string }) => {
      const { code } = formData;
      this._loaderService.show();
      return confirmSignIn({ challengeResponse: code });
    },

    handleForgotPassword: async (formData: { username: string } | string) => {
      this._loaderService.hide();
      const username =
        typeof formData === 'string' ? formData : formData.username ?? '';
      return resetPassword({ username });
    },

    handleForgotPasswordSubmit: async (formData: {
      username: string;
      code: string;
      password: string;
    }) => {
      const { username, code, password } = formData;
      await confirmResetPassword({
        username,
        confirmationCode: code,
        newPassword: password,
      });
      const clientMetadata = await getLoginClientMetadata();
      return signIn({
        username,
        password,
        options: { clientMetadata },
      });
    },
  };

  constructor(
    private _auth: AuthService,
    private _loaderService: LoaderService,
    public authenticator: AuthenticatorService,
    private _router: Router
  ) {}

  ngOnInit(): void {}
}
